/** Breakpoint alinhado ao menu (Sidebar, Locações mobile, etc.). */
export const MOBILE_MAX_WIDTH_PX = 800;

export const getMobileMediaQuery = () =>
  typeof window !== 'undefined'
    ? window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`)
    : null;

/**
 * Mantém isMobile sincronizado com o viewport (resize, DevTools, rotação).
 * @param {(isMobile: boolean) => void} onChange
 * @returns {() => void} unsubscribe — chamar no componentWillUnmount
 */
export function subscribeMobileLayout(onChange) {
  const mql = getMobileMediaQuery();
  if (!mql) {
    onChange(false);
    return () => {};
  }

  const handler = () => onChange(mql.matches);
  onChange(mql.matches);

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }

  mql.addListener(handler);
  return () => mql.removeListener(handler);
}
